<template>
    <div>
    <link type="text/css" rel="stylesheet" href="/css/posterTvGrid.css"/>
    <link type="text/css" rel="stylesheet" href="/css/backSideStyle_custom.css"/>
    <nav class="navbar Customize navbar-light">
      <a class="navbar-brand" href="/backend">
        <img
          src="/images/backend/favicon.png"
          alt="首頁圖示"
          class="logo_01"/>
        
            國立臺灣大學生物產業傳播暨發展學系 — 後台管理系統
        </a>
    </nav>
    <b-container fluid>
        <div class="mcomarall">
            <Header :header="header"></Header>
            <b-form-group class="mt-1" style="margin-left: 20%;">
                <b-row style="width: 50%; margin: 2% !important; display: inherit; ">
                    <b-col>
                        <label>請輸入新密碼</label>
                        <p>{{ pwdNote }}</p>
                    </b-col>
                    <b-col>
                        <b-form-input
                        v-model="content.pwd"
                        :type="passSetting.type"
                        placeholder="請輸入新密碼"
                        required
                        maxlength="12">
                        </b-form-input>
                        <a href="#" @click="showPwdEye(passSetting)">
                            <img class="showeye" v-bind:src="'/images/backend/'+passSetting.image" alt="顯示或隱藏明碼"></img>
                        </a>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group class="mt-1" style="margin-left: 20%;">
                <b-row style="width: 50%; margin: 2% !important; display: inherit; ">
                    <b-col>
                        <label>再次輸入新密碼</label>
                    </b-col>
                    <b-col>
                        <b-form-input
                        v-model="content.chkpwd"
                        :type="confpassSetting.type"
                        placeholder="再次輸入新密碼"
                        required
                        maxlength="12">
                        </b-form-input>
                        <a href="#" @click="showPwdEye(confpassSetting)">
                            <img class="showeye" v-bind:src="'/images/backend/'+confpassSetting.image" alt="顯示或隱藏明碼"></img>
                        </a>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group class="mt-1" style="margin-left: 20%;">
                <b-row style="width: 50%; margin: 2% !important; display: inherit; ">
                    <b-col>
                        <label>驗證碼</label>
                    </b-col>
                    <b-col style="display: inline-flex; align-items: center;">
                        <input type="tel" maxlength="6" class="passcode p-2" v-model="content.code" placeholder="請輸入驗證碼" ></input>
                        <img
                            :src="imageCode"
                            alt="captchaImage"
                            class="captcha"
                            style="height: 55px !important;" />
                        <a
                            href="javascript:void(0)"
                            class="reload"
                            title="點我可重新產生驗證碼"
                            @click="getImageCode">

                            <img src="/images/backend/icon-restart.png" alt="點我可重新產生驗證碼"/>
                        </a>
                    </b-col>
                </b-row>
                <b-row style="margin: 2% !important;">
                    <b-button @click="save">
                            變更密碼
                    </b-button>
                </b-row>
            </b-form-group>

        </div>
    </b-container>


  </div>
</template>
<script>
import Header from '../../components/admin/NavBar/Header.vue';

export default{
    components:{
        Header,
    },
    data(){
        return{
            //標頭
            header:{
                text1:'忘記密碼',
            },
            pwdNote:"(密碼長度6-12個字元，以英文大小寫、數字等限定，需至少一位大寫、一位小寫、一位數字、一位特殊字元(如：!@#$%^&*)。)",
            //密碼顯示設定
            passSetting:{
                show: false,
                type: "password",
                image: "eye.png",
            },
            //確認密碼顯示設定
            confpassSetting:{
                show: false,
                type: "password",
                image: "eye.png",
            },
            //設定參數
            content:{},
            passTokne:"",
            type:"",

            //圖形驗證碼變數
            imageCode:"",
            imageCodeArr:"",
           //API設定區
            apiGetImageCode:(data)=> this.userRequest.post("bicd/GetImageCode",data),
            apiUserInfo: (data) =>this.userRequest.post("bicd/UserInfo", data),
        }
    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        
    },
    methods:{
        //初始化
        init(){
            this.showPwdEye(this.passSetting,'init');
            this.showPwdEye(this.confpassSetting,'init');
            this.getImageCode();
            this.PassToken = this.$route.query.Token;
            this.type = this.$route.query.Type;
        },
        //取得驗證圖
        getImageCode(){
            this.apiGetImageCode()
                .then((res) => {
                    const json = JSON.parse(res.data);
                    if (json.Status) {
                        let jsonImage = JSON.parse(json.Data);
                        this.imageCode = jsonImage.Image;
                        this.imageCodeArr = jsonImage.Code.split("");
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        //儲存
        save(){
            //資料判斷
            if(!this.content.pwd ){
                alert("密碼不得為空");
            }else{
                if(this.content.pwd  === this.content.chkpwd){
                    //POST 參數
                    let json = {
                        TYPE:"FORGET_CHANGEPASS",
                        user_info_FORGET_PASS:{
                            PassToken: this.PassToken,
                            DecryptionPass: this.content.pwd,
                            ImgCodePass: this.content.code,
                        },
                    };
                    this.FunctionToken(this.ResetUserInfoPwd, json);
                }else{
                    //新帳號與確認帳號不一樣時
                    alert("請確認密碼是否相同");
                    //清除紀錄
                    getImageCode();
                    this.contend = {};
                }
            }
        },
        //重設密碼
        ResetUserInfoPwd(data){
            this.apiUserInfo(data)
                .then((res) => {
                    const json = JSON.parse(res.data);
                    if(json.Status){
                        let jsonData =JSON.parse(json.Data);
                        alert("更新成功！");
                        this._go('/ISY');
                    }else{
                        alert(json.Data);
                    }
                }).catch((err)=> {
                    console.log("ErrFunction: ResetUserInfoPwd/n "+err);
                });
        }
    }
}
</script>